import http from '@/http'

const API_PATH = 'user/account/license_plan'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  async update({ commit }, payload) {
    const params = JSON.stringify({
      account: payload.account,
      licensePlan: payload.licensePlan
    })
    await http.put(API_PATH, params).then(() => {
      commit('setHttpSuccess', '有料ライセンスの申し込みが完了しました。', { root: true })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
